import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, User, Calendar, Activity, CheckCircle, AlertTriangle } from 'lucide-react';
import { API_URL } from '../config/api';
import ResultForm from '../components/ResultForm';
import './Studies.css';

const StudyDetail = () => {
    const { id } = useParams();
    const [study, setStudy] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showResultForm, setShowResultForm] = useState(null); // sampleId to show form for

    useEffect(() => {
        fetchStudyDetails();
    }, [id]);

    const fetchStudyDetails = async () => {
        try {
            const response = await fetch(`${API_URL}/studies/${id}`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            });
            if (response.ok) {
                const data = await response.json();
                setStudy(data);
            }
        } catch (error) {
            console.error('Error fetching study details:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleResultSuccess = () => {
        setShowResultForm(null);
        fetchStudyDetails(); // Refresh to show new status/samples
    };

    if (loading) return <div className="p-4">Cargando detalles...</div>;
    if (!study) return <div className="p-4">Estudio no encontrado</div>;

    return (
        <div className="studies-container">
            <div className="studies-header">
                <div className="header-left">
                    <Link to="/dashboard" className="btn-icon-back"><ArrowLeft size={24} /></Link>
                    <h2>Detalle del Estudio #{study.id}</h2>
                </div>
                <span className={`badge badge-${study.status === 'completed' ? 'success' : 'warning'}`}>
                    {study.status.replace(/_/g, ' ').toUpperCase()}
                </span>
            </div>

            <div className="study-grid">
                {/* Patient Info Card */}
                <div className="card info-card">
                    <h3><User size={18} /> Información del Paciente</h3>
                    <div className="info-row">
                        <strong>Nombre:</strong> {study.first_name} {study.last_name} {study.maternal_last_name || ''}
                    </div>
                    <div className="info-row">
                        <strong>Fecha Nac.:</strong> {study.date_of_birth}
                    </div>
                    <div className="info-row">
                        <strong>Estudio:</strong> {study.name}
                    </div>
                </div>

                {/* Timeline / Samples */}
                <div className="card timeline-card">
                    <h3><Activity size={18} /> Historial de Muestras</h3>

                    <div className="timeline">
                        {study.samples?.map((sample, index) => (
                            <div key={sample.id} className={`timeline-item ${sample.status}`}>
                                <div className="timeline-marker">{index + 1}</div>
                                <div className="timeline-content">
                                    <div className="timeline-header">
                                        <h4>Muestra #{sample.sample_number} ({sample.type})</h4>
                                        <span className="date">{new Date(sample.created_at).toLocaleString()}</span>
                                    </div>
                                    <p>Código: <strong>{sample.sample_code}</strong></p>
                                    <p>Estado: {sample.status}</p>

                                    {sample.results ? (
                                        <div className="result-box">
                                            <h5>Resultado:</h5>
                                            <p className="result-text">{sample.results.findings}</p>
                                            <small>Validado el: {new Date(sample.results.created_at).toLocaleString()}</small>
                                        </div>
                                    ) : (
                                        <div className="action-box">
                                            {showResultForm === sample.id ? (
                                                <ResultForm sampleId={sample.id} onSuccess={handleResultSuccess} />
                                            ) : (
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => setShowResultForm(sample.id)}
                                                >
                                                    Capturar Resultado
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudyDetail;
